const initialState = {
  name: "Demo",
  iconSmall: "",
  iconMedium: "",
  iconLarge: "",
  imageSmall: "",
  imageMedium: "",
  imageLarge: ""
}


function currentCompany(state = initialState, action) {  
    return state; 
  }


export default currentCompany
